import { useMemo } from 'react';
import { useTheme } from "@stores/ThemeContext";
import { MatchStatusType } from '@utils/types';
import { T } from "@utils/enums";

interface StatusStyles {
    background: string;
    border: string;
    text: string;
}

export const useMatchStatusStyles = (status: MatchStatusType): StatusStyles => {
    const { theme } = useTheme();
    
    return useMemo(() => {
        const defaultStyles: StatusStyles = {
            background: '',
            border: '',
            text: ''
        };

        if (!status) return defaultStyles;

        switch (status) {
            case T.W:
                return {
                    background: 'bg-success',
                    border: 'border-success',
                    text: 'text-monoY'
                };
            case T.F:
            case T.L:
                return {
                    background: 'bg-error',
                    border: 'border-error',
                    text: 'text-monoY'
                };
            case T.D:
                return {
                    background: 'bg-base0',
                    border: 'border-base0',
                    text: 'text-monoY'
                };
            default:
                return defaultStyles;
        }
    }, [status, theme]);
};